<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part"> <div class="title-block" id="rw-title-block_107252-00001"><h1><a href="#/a9781847674562_tableofcontents">THE<br/> EXPLOITS<br/> OF BRIGADIER<br/> GERARD</a></h1>
<p>—</p>
</div> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a9781847674562_part_01.vue?4b210a7c